import { Component, h } from 'preact'
import globals, { subscribe } from '../../utils/globals'
import algoliasearch from 'algoliasearch/lite'
import { Tag } from './PublicTagSelect'
import Icon from '../assets'
import getWithInMemoryCache from '../../utils/getWithInMemoryCache'
import { SEARCH_TOKEN_URL } from '../../libs/config'

interface Props {
  isTagSelected: (tag: string) => boolean,
  selectPublicTag: (tag: Tag, remainFocusOnInput: boolean) => void
}
interface State {
  suggestedTags: string[],
  index?: algoliasearch.Index
}
interface HitWithTags {
  tags: string[] | null
}
interface Hash<T> {
  [key: string]: T;
}

export default class AutoSuggestTags extends Component<Props, State> {
  index: algoliasearch.Index

  constructor (props: Props) {
    super(props)
    this.state = {
      suggestedTags: []
    }
    subscribe('title_changed', ({ title } : { title: string }) => this.autoSuggest(title))
  }

  async componentDidMount () {
    const data: {client_id: string, token: string} = await getWithInMemoryCache(SEARCH_TOKEN_URL, {})
    const client = algoliasearch(data.client_id, data.token)
    this.setState({ index: client.initIndex(`${globals('communityId')}`) })
  }

  autoSuggest (topicName: string) {
    const { index } = this.state
    if (topicName === '' || index === undefined) {
      this.setState({ suggestedTags: [] })
      return
    }
    index.search({ query: topicName, attributesToRetrieve: ['title', 'tags'] }).then(({ hits }: { hits: HitWithTags[] }) => {
      let tagSet: Hash<number> = {}
      const results = hits.reduce((result, hit) => {
        hit.tags && hit.tags.forEach(tag => {
          result.hasOwnProperty(tag) ? result[tag]++ : result[tag] = 1
        })
        return result
      }, tagSet)
      this.setState({ suggestedTags: Object.keys(results).sort((a, b) => results[b] - results[a]).slice(0, 3) })
    })
  }

  render ({ isTagSelected, selectPublicTag }: Props, { suggestedTags }: State) {
    return suggestedTags.length > 0 && <div class='public-tag-suggestions-container'>
      {
        suggestedTags.map(tag => isTagSelected(tag) ? null : <div class='suggested-public-tag' onClick={
          () => selectPublicTag({ name: tag }, false)
        }>{tag}&nbsp;<Icon icon='add' size={16} /></div>)
      }
    </div>
  }
}
